import { useDispatch } from "react-redux";
import { removeDriver } from "../../../reducers/driverManagement/thunkActions";
import { Modal } from "../Modal";
import { RemoveDriverContent } from "./RemoveDriverContent";
import { RemoveDriverActions } from "./RemoveDriverActions";

export const RemoveDriverModal = ({ onClose, driver }) => {
  const dispatch = useDispatch();

  const onContinue = async () => {
    const { error } = await dispatch(removeDriver(driver));
    !error && onClose();
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      title={"Remove Driver"}
      content={<RemoveDriverContent driver={driver} />}
      actions={
        <RemoveDriverActions onCancel={onClose} onContinue={onContinue} />
      }
      maxWidth={"sm"}
    />
  );
};
